module.exports = __webpack_public_path__ + "img/ipfs.b1123710.png";